<template>
    <div>
        <div class="location_css">
      <img src="../../assets/img/location.png" />
      <div>当前位置：</div>
      <div @click="goSy()">首页</div>
      <div><i class="el-icon-arrow-right"></i></div>
      <div @click="$router.push('/goods')">精品展示</div>
      <div><i class="el-icon-arrow-right"></i></div>
      <div class="location_text">{{detail.wineName}}</div>
    </div>
        <div class="culture_main" v-loading="loading">
            <div class="culture_right">
                <div class="culture_right_title">
                    <div class="culture_right_text">
                        <img src="../../assets/img/jiujia.png" style="width: 19px;height: 21px;">
                        <div>{{detail.restaurantName}}</div>
                    </div>
                </div>
                <div class="company_item">
                    <div style="display: flex;">
                        <img class="company_img" :src="detail.wineImage" style="width: 204px;height: 265px;">
                        <div>
                            <div class="company_title">{{detail.wineName}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">价格：</span>{{detail.winePrice}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">净含量：</span>{{detail.wineSpec}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">酒精度：</span>{{detail.wineAbv}}</div>
                        </div>
                    </div>
                    <div>
                        <div class="company_title">产品介绍</div>
                        <div class="company_content">{{detail.wineDescription || "暂无"}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            productList: [],
            detail:{}
        }
    },
    methods: {
        //获取商家产品
        getProductList: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("fx-web/wine/page/wine", { params: { pageNum: 1, pageSize: 10000 } }).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        vue.productList = resp.data.dataList;
                    } else {
                        vue.$message.warning(resp.errtext);
                    };
                    vue.loading = false;
                    resolve();
                }, function() {
                    vue.loading = false;
                    resolve();
                });
            });
        },
    },
    mounted() {
        let vue = this;
        vue.loading = true;
        this.getProductList().then(function() {
            vue.detail = vue.productList.find(item => item.wineId == vue.$route.query.id);
        });
    }
}
</script>